import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboarding } from '../context/OnboardingContext';
import PageLayout from '../components/PageLayout';
import FormInput from '../components/FormInput';
import { NAME_MAX, validateName } from '../utils/signupValidation';

const OnboardingFirstName = () => {
  const { formData, updateField } = useOnboarding();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const handleNext = (e) => {
    e?.preventDefault();
    const newErrors = {};
    const firstNameError = validateName(formData.firstName, 'Le prénom');
    const lastNameError = validateName(formData.lastName, 'Le nom');
    if (firstNameError) newErrors.firstName = firstNameError;
    if (lastNameError) newErrors.lastName = lastNameError;
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }
    // Espaces de début/fin retirés une fois pour toutes : c'est ce qui sera envoyé.
    updateField('firstName', formData.firstName.trim());
    updateField('lastName', formData.lastName.trim());
    navigate('/onboarding/naissance');
  };

  return (
    <PageLayout step={0}>
      <h2 className="title">Quel est votre prénom ?</h2>
      <p className="subtitle">Nous aimerions mieux vous connaître</p>

      <form onSubmit={handleNext} noValidate>
        <FormInput
          type="text"
          name="given-name"
          autoComplete="given-name"
          autoCapitalize="words"
          maxLength={NAME_MAX}
          placeholder="Votre prénom *"
          value={formData.firstName}
          error={errors.firstName}
          onChange={(e) => { updateField('firstName', e.target.value); setErrors((err) => ({ ...err, firstName: undefined })); }}
        />
        {errors.firstName && <p className="signup-error">{errors.firstName}</p>}

        <FormInput
          type="text"
          name="family-name"
          autoComplete="family-name"
          autoCapitalize="words"
          maxLength={NAME_MAX}
          placeholder="Votre nom *"
          value={formData.lastName}
          error={errors.lastName}
          onChange={(e) => { updateField('lastName', e.target.value); setErrors((err) => ({ ...err, lastName: undefined })); }}
        />
        {errors.lastName && <p className="signup-error">{errors.lastName}</p>}

        <div className="button-group">
          <button type="submit" className="btn btn--primary">Continuer &gt;</button>
        </div>
      </form>
    </PageLayout>
  );
};

export default OnboardingFirstName;
